/**
 * 将手机号格式化为前3位后4位循环的格式
 * @param value 手机号
 * @example $mobile(13155874439) => '131 5587 4439'
 */
export default function (value: string = ''): string{
	return String(value).substring(0, 3) + ' ' + String(value).substring(3).replace(/(\d{4})(?=\d)/g, '$1' + ' ');
}
